import { render } from "./EmployeeApprovedPayments.vue?vue&type=template&id=31bdda6c"
import script from "./EmployeeApprovedPayments.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovedPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__